

import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';


const firebaseConfig = {

  apiKey: "AIzaSyAQgU8VRqa5HKr2xSodtzbPNERHCrcpYfw",

  authDomain: "dells-car-rental.firebaseapp.com",

  projectId: "dells-car-rental",

  storageBucket: "dells-car-rental.appspot.com",

  messagingSenderId: "853188618216",

  appId: "1:853188618216:web:c4d013b51c0d3d932ae65d"

  

  
  
  };
  
  
  

  const app = initializeApp(firebaseConfig);
  const db = getFirestore(app);
  const storage = getStorage(app);
  
  export { db, storage };